<template>
	<router-link class="router-button" :class="'btn-'+themeColor"
				 :to="to"
				 :title="title">
		{{title}} <span v-if="batchNo" class="batch">{{batchNo}}</span>
	</router-link>
</template>

<script>
	export default {
		name: "RouterButton",
		props: {
			to: String,
			title: String,
			themeColor: {
				type: String,
				default: 'primary'
			},
			batchNo: Number | String
		}
	}
</script>

<style scoped>

</style>
